<template>
  <v-card
    class="rounded-xl overflow-visible toggle-container"
    flat
    :color="backgroundColor"
    :elevation="elevation"
    style="border-radius: 24px !important; position: relative;"
  >
    <v-row no-gutters class="d-flex">
      <v-col
        v-for="(option, key) in options"
        :key="key"
        class="flex-grow-1 d-flex align-center justify-center"
      >
        <v-btn
          class="text-none font-weight-medium text-body-1 toggle-btn"
          :color="changeColor(option.value)"
          :class="getButtonClass(option.value)"
          block
          depressed
          :disabled="disabled"
          @click="!disabled && $emit('update:modelValue', option.value)"
        >
          {{ option.text }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  export default {
    name: "ToggleView",
    props: {
      modelValue: {
        type: String,
        required: true,
      },
      options: {
        type: Array,
        required: true,
        validator: function(value) {
          return value.every(
            (option) =>
              typeof option === "object" &&
              option.hasOwnProperty("value") &&
              option.hasOwnProperty("text")
          );
        },
      },
      backgroundColor: {
        type: String,
        default: "#f5f5f5",
      },
      primaryColor: {
        type: String,
        default: "primary",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      elevation: {
        type: [Number, String],
        default: 0,
      },
    },
    methods: {
      changeColor(value) {
        return this.modelValue === value
          ? this.primaryColor
          : this.backgroundColor;
      },
      getButtonClass(value) {
        return this.modelValue === value ? "active-button" : "inactive-button";
      },
    },
    emits: ["update:modelValue"],
  };
</script>

<style scoped>
  .toggle-container {
    position: relative;
    padding: 2px;
    border-radius: 24px !important;
    margin: 0px !important;
  }

  .toggle-btn {
    border-radius: 24px !important;
    margin: 0px !important;
    font-size: 14px !important;
    min-height: 36px !important;
    padding: 0 6px !important;
  }

  .active-button {
    color: white !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }

  .inactive-button {
    color: #999 !important;
  }
</style>
